module.exports = __webpack_public_path__ + "img/venue-gray-4.f0c1a3d5.png";